import { Image } from "antd";
import { sharpelyLogoLight } from "assets/images";
import React from "react";
import { Link, Redirect } from "react-router-dom";
import { toast } from "react-toastify";
import { useAuth } from "../../context/AuthContext";
import { cyrb53 } from "../../Libs/cyrb53Hasher";
import db from "../../Libs/db";
import AdminServices from "../../services/api/AdminServices";
import styles from './auth.module.css';

const Register = (props) => {
    const [email, setEmail] = React.useState('');
    const [name, setName] = React.useState('');
    const [phone, setPhone] = React.useState('');
    const [otp, setOTP] = React.useState('');
    const [mainOTP, setmainOTP] = React.useState('');
    const [nextBtnPressed, setNextBtnPressed] = React.useState(false);
    const { setIsAuth, isAuth } = useAuth();
    const isProd = process.env.NODE_ENV === 'production'
    const checkOTP = async (e) => {
        e.preventDefault();
        if (Number(otp) === Number(mainOTP)) {
            const data = {
                mobileNumber: phone, // will be blank if skip is pressed
                email: email,
                clientName: name,
                source: "web"
            }
            console.log(data)
            try {
                const res = await AdminServices.createIFA(data).then((res) => res)
                console.log(res)
                if (res.type) {
                    if (res.data.Result === 'success') {
                        const userData = {
                            name: name,
                            email: email,
                            mobile: phone,
                            id: res.data.ClientId,
                            isLogged: true,
                        };
                        db.set(db.model.ifa, JSON.stringify({ userData }));
                        localStorage.setItem("isAdmin", cyrb53("yesitisamintboxadmin"));
                        setIsAuth(true);
                        props.history.push("/dashboard")
                        setNextBtnPressed(false);
                    } else {
                        toast.error("Try again ...");
                        setNextBtnPressed(false);
                    }
                } else {
                    toast.error("Try again ...");
                    setNextBtnPressed(false);
                }
            } catch (error) {
                toast.error("Try again ...");
                setNextBtnPressed(false);
            }

        } else {
            toast.error("Incorrect OTP. Try again ...");
            setNextBtnPressed(false);
        }
    }

    const sendOTP = async (id) => {
        try {
            setmainOTP('')
            const res = await AdminServices.generateOTP(email, "EMAIL").then((res) => res)
            if (res.type) {
                if (res.data.Result === 'success') {
                    setmainOTP(res.data.otpcode);
                    setNextBtnPressed(true);
                    toast.success("OTP sent on mail");
                } else {
                    toast.error("Try again ...");
                }
            } else {
                toast.error("Try again ...");
            }
        } catch (error) {
            toast.error("Try again ...");
        }
    };

    const onNextBtnPressed = async (e) => {
        e.preventDefault();
        console.log("DSFDSF")
        try {
            const res = await AdminServices.ifaExists(email, "EMAIL").then((res) => res);
            console.log("DSFDSF", res)
            if (res.type) {
                console.log("client exists API ", res.data)
                if (res.data.AdvisorId !== '') {
                    setNextBtnPressed(false);
                    toast.info("Already a mintbox registered IFA!! Please Login.");
                } else {
                    sendOTP(res.data.AdvisorId)
                }
            } else {
                toast.warn("Try again ...");
                setNextBtnPressed(false);
            }
        } catch (error) {
            toast.warn("Try again ...");
            console.log("DSFDSFsda", error)
            setNextBtnPressed(false);
        }
    };

    if (isAuth || isProd) {
        return <Redirect to='/dashboard' />
    }
    return (
        <div className={styles.auth} >
            <div className={`${styles.container} rounded`}>
                <div>
                    <Image src={sharpelyLogoLight} alt="logo" height='32px' preview={false} />
                </div>
                <h4 className='mt-3 font-weight-normal'>
                    New here?
                </h4>
                <h6 className='font-weight-light mb-3'>Signing up is easy. It only takes a few steps.</h6>
                <form
                    name="normal_login"
                    className="login-form w-100"
                    onSubmit={!nextBtnPressed ? (e) => onNextBtnPressed(e) : (e) => checkOTP(e)}
                >
                    {!nextBtnPressed ? <div>
                        <input type="text" value={name} className='w-100 p-2' placeholder="Name" onChange={(e) => {
                            setName(e.target.value)
                        }} />
                        <input value={email} onChange={(e) => setEmail(e.target.value)}
                            className='w-100 p-2 mt-4' placeholder='Email' type='email' />
                        <input type="number" value={phone} className='w-100 p-2 mt-4' placeholder="Phone number" onChange={(e) => {
                            setPhone(e.target.value)
                        }} />
                    </div> :
                        <input value={otp} onChange={(e) => setOTP(e.target.value)}
                            className='w-100 p-2 ' placeholder='OTP' type='pin' />
                    }
                    <button type='submit' className='w-100 mt-4 btn-primary rounded p-2'>
                        {nextBtnPressed ? "Register" : "Send OTP"}
                    </button>
                </form>
                <div className="text-center mt-4 font-weight-light" style={{ fontSize: "14px" }}>
                    Already have an account? <Link to="/login" className="text-primary" style={{ fontSize: "14px" }}>Login</Link>
                </div>
            </div>
        </div>
    )
}

export default Register